// Onboard-Watchdog: reine Schwellen-Logik, getrennt vom Component, damit sie ohne
// Browser/React unit-testbar ist (node importiert .mjs nativ; Vite resolved .mjs auch
// extensionslos). KEINE React-/Theme-Imports hier — pure function.
//
// Zwei Stufen statt hart-aus bei Verbindungs-Blip:
//   "ok"   — Status frisch genug, alles normal
//   "soft" — Endpoint kurz stumm (>SOFT_MS): Reconnect-Hinweis, ABER weiterpolllen
//   "hard" — Endpoint zu lange stumm (>HARD_MS): Backend gilt als tot, harter Abbruch
// (behebt den B3-Fehlalarm: ein ~15s CF/Tunnel-Blip koppelte die UI früher dauerhaft ab).

export const SOFT_MS = 15000;   // ≈ 5 verpasste 3s-Polls — Reconnect-Schwelle
export const HARD_MS = 90000;   // wirklich tot — bewahrt den 0e080a0-Zweck (kein Endlos-Hang)

/**
 * @param {number} msSinceOk  Millisekunden seit dem letzten GÜLTIGEN /onboard/status
 * @returns {"ok"|"soft"|"hard"}
 * Grenzen (strict-greater, wie der bisherige Watchdog `> STATUS_TIMEOUT_MS`):
 *   msSinceOk <= SOFT_MS          -> "ok"
 *   SOFT_MS < msSinceOk <= HARD_MS -> "soft"
 *   msSinceOk > HARD_MS           -> "hard"
 */
export function classifyStall(msSinceOk, soft = SOFT_MS, hard = HARD_MS) {
  if (msSinceOk > hard) return "hard";
  if (msSinceOk > soft) return "soft";
  return "ok";
}
